// extracted by mini-css-extract-plugin
export default {"button":"styles_button__r8tUf","transparent-button":"styles_transparent-button__ZFnCT"};